import { css } from '@emotion/css';
import { Button, Headline, TextButton } from '@volumental/common';
import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import Intro from '../../components/intro';
import { PrivacyFooter } from './privacy-footer';

const buttonContainer = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 140px;
`;

const contentStyle = css`
  padding: 0px 24px;
`;

interface TopBannerImageIntroProps {
  onClose: () => void;
  onClick: () => void;
  onAlternative?: () => void;
  showAlternative: boolean;
  headLine: string;
  mainBtTitle: string;
  alternativeBtTitle: string;
  bannerImg: string;
}
export function TopBannerImageIntro({
  onClose,
  onClick,
  onAlternative,
  showAlternative,
  mainBtTitle,
  alternativeBtTitle,
  headLine,
  bannerImg,
}: TopBannerImageIntroProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <Intro imgSrc={bannerImg} close={onClose} imgAlt={t('imageAlt.intro')}>
      <div className={contentStyle}>
        <Headline style={{ textAlign: 'center', margin: '2rem 0' }}>
          {headLine}
        </Headline>
        <div className={buttonContainer}>
          <Button loading={false} type="submit" onClick={onClick}>
            {mainBtTitle}
          </Button>
          {showAlternative && (
            <TextButton onClick={onAlternative}>
              {alternativeBtTitle}
            </TextButton>
          )}
        </div>
      </div>
      <PrivacyFooter />
    </Intro>
  );
}
